import { lazyLoad } from '../../../../shared/utils/loadable';

export const UserWithholdings = lazyLoad(
  () => import('./index'),
  (module) => module.UserWithholdings,
);
